export default __webpack_public_path__ + "static/media/OTorpedoOpen.8d96bfe4.jpg";